export default __webpack_public_path__ + "static/media/barcel.99a1439c.png";